<label class="checkbox">
  <span class="checkbox__checkmark-container">
    <input type="checkbox" [formControl]="fc" class="d-none" />
    <span *ngIf="fc.value" class="checkbox__checkmark"></span>
  </span>
  <span class="checkbox__label">{{ label }}</span>
</label>
